import CRUDActions from './CRUD';
import News from '../api/news/news';
import {share} from './facebook';
import {AwsVideo} from "../api/videoAws";
import {VideoModel} from "../api/video";

class NewsCRUDActions extends CRUDActions {
  prefix = 'news';

  get _model() {
    return News;
  }

  /**
   * save data to state. Using assign to object is bad practice.
   *
   * @param ActiveRecord model
   * @returns {Function}
   */
  save(model, data) {
    return async(dispatch) => {
      try {
        dispatch({
          type: this.saveItemAction
        });

        if (data.video instanceof VideoModel) {
          data.video = await AwsVideo.uploadVideo(data.video);
        }
        await model.save(data);

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model
        });

        return model;
      }

      catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });

        throw error;
      }
    };
  }

  /**
   *
   * @param {News} model
   * @returns {function(*)}
   */
  publish(model: News) {
    return async(dispatch) => {
      dispatch({
        type: this.saveItemAction,
        id: model.id
      });
      try {
        let updatedModel = await model.publish();

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model: updatedModel
        });

        return true;
      }
      catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });
        return false;
      }
    }
  }

  share(model: News) {
    return async(dispatch) => {
      let shareLink = await model.share();
      share(shareLink);
    }
  }

  publishCurrentModel() {
    return async(dispatch, getState) => {
      let state = getState();
      return await dispatch(this.publish(state.news.model));
    }
  }
}


export default new NewsCRUDActions();



// WEBPACK FOOTER //
// ./src/actions/news.ts